module.exports = __webpack_public_path__ + "img/cpzxIcon2.790c60a5.png";